import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const addRoleByAdminApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction( data,
 apiConstants.USER.ADD_ROLE
    
 
    )
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
